//import { HttpClient , HttpHeaders, HttpRequest, HttpEvent, HttpParams } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router } from '@angular/router';
import { UserserviceService } from '../userservice.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { HttpClient, HttpHeaders, HttpRequest, HttpEvent, HttpParams } from '@angular/common/http';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit {
  public formControl = new FormControl();
  Registerform!:FormGroup;
  submitted = false;
  allfeesdata: any;
  proccessing: boolean=false;

  //Registerform: any;
   constructor(private service:UserserviceService ,public router: Router,private httpClient: HttpClient,private route: ActivatedRoute,private formBuilder: FormBuilder) { 
    this.Registerform = formBuilder.group({
      
      // saluation:['',Validators.required],
      stud_name:['',Validators.required],
      standard:['',Validators.required],
      application_type:['',Validators.required],
      mobile_no:['',[Validators.required, Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$")]],
      email_address:['',[Validators.required,Validators.email,Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]],
    })
  }
  get f() { return this.Registerform.controls; }
  
  ngOnInit(): void {
    if(sessionStorage.getItem('loggeduser')){
      alert("Please Log Off to register New appliction!");
      this.router.navigate(['/dashboard']);
    }
    this.getallapplications();
    // window.location.reload();
    // sessionStorage.setItem('loggeduser','newentry');
  //this.getAllDatafromAPI();   
  }
  
getAllDatafromAPI(regform:any){
    this.submitted = true;
if (this.Registerform.invalid) {
   alert("Please Fill all details");    
    return;
}
  this.proccessing=true;
  let loginuserdetail:{stud_name:any,standard:any,application_type:any,mobile_no:any,email_address:any}
  ={
    stud_name:this.Registerform.value.stud_name.trim(),
    // saluation:this.Registerform.value.saluation,
    standard:this.Registerform.value.standard,
    application_type:this.Registerform.value.application_type,
    mobile_no:this.Registerform.value.mobile_no,
    email_address:this.Registerform.value.email_address
  };
    this.service.post('/Student_module/registration/',loginuserdetail).subscribe((res:any)=>{
    if(res.status=="success"){      
      this.proccessing=false;
      setTimeout(()=>{                          
        alert(res.Data);
        // window.location.reload();
        this.router.navigate(['/Login']);
      }, 500);
    }
    else if(res.status=="failed"){
      this.proccessing=false;
      setTimeout(()=>{                          
        alert(res.Data);
        window.location.reload();
      }, 500);
    }

  });
}

getallapplications(){
  this.service.post('/Boardadmin_module/getallapplicationsfees',{}).subscribe((res:any)=>{
   // console.log(res.Data)
   if(res.status=="success"){
       this.allfeesdata=res.Data;
      }
      else{
         alert("Something went wrong!, please refresh page.");
         window.location.reload();
      }
   });

}

}



